export const SliderData = [
  {
    image: 'https://i.ibb.co/515KbV6/hydraulica-banner-home-1.png',
    link: ""
  },
  {
    image: 'https://i.ibb.co/mB5Xdzn/hydraulica-banner-home-2.png',
    link: "./fornecedores"
  },
  {
    image: 'https://i.ibb.co/5r5BBVL/hydraulica-banner-home-3.png',
    link: ""
  },
  {
    image: 'https://i.ibb.co/kqgGPLr/hydraulica-banner-home-4.jpg',
    link: "./lojas"
  },
  {
    image: 'https://i.ibb.co/Gt4xGPF/hydraulica-banner-home-5.jpg',
    link: "./epi"
  },
  {
    image: 'https://i.ibb.co/PCwFb5v/hydraulica-banner-home-6.jpg',
    link: "./hidraulica"
  },
  {
    image: 'https://i.ibb.co/ZJDFcM9/hydraulica-banner-home-7.jpg',
    link: "./lojas"
  },
  {
    image: 'https://i.ibb.co/GQ9dMK5/hydraulica-banner-home-8.jpg',
    link: "./ferragens"
  },
  {
    image: 'https://i.ibb.co/4Rh3XF2/hydraulica-banner-home-9.jpg',
    link: "./pintura"
  },
  {
    image: 'https://i.ibb.co/zHXVKSZ/hydraulica-banner-home-10.jpg',
    link: "./ferragens"
  },
  {
    image: 'https://i.ibb.co/SdJtGsr/hydraulica-banner-home-11.jpg',
    link: "./eletrica"
  },
]